import { render, staticRenderFns } from "./LayoutBento.vue?vue&type=template&id=d595223e&scoped=true"
import script from "./LayoutBento.vue?vue&type=script&lang=js"
export * from "./LayoutBento.vue?vue&type=script&lang=js"
import style0 from "./LayoutBento.vue?vue&type=style&index=0&id=d595223e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d595223e",
  null
  
)

export default component.exports